import { SimulationRepository } from '@/models/Simulation/SimulationRepository'

export const setSimulationIsRunning = async simulationList => {
  simulationList.items
    .filter(simulation => simulation.e2eResultHash == undefined)
    .map(simulation => (simulation.isRunning = false))
  const e2eSimulations = simulationList.items.filter(
    simulation => simulation.e2eResultHash !== undefined,
  )
  const e2eSimulationPhases = await Promise.all(
    e2eSimulations.map(simulation => getSimulationPhase(simulation)),
  )
  e2eSimulations.map(simulation => {
    const targetSimulation = e2eSimulationPhases.find(
      e2eSimulationPhase => simulation.id === e2eSimulationPhase.id,
    )
    if (targetSimulation === undefined) return false
    const isRunning = (() => {
      if (
        targetSimulation.phase === 'queued' ||
        targetSimulation.phase === 'running'
      )
        return true
      if (
        targetSimulation.phase === 'cached' ||
        targetSimulation.phase === 'completed'
      )
        return false
    })()
    simulation.isRunning = isRunning
  })
  return simulationList
}

const getSimulationPhase = async simulation => {
  // シミュレーションのフェーズを取得
  const result = await SimulationRepository.getByConditionHash(
    simulation.e2eResultHash,
  )
  if (!result) {
    // 結果が取得できない場合contentがないため
    return { id: simulation.id, phase: 'running' }
  }
  return { id: simulation.id, phase: result.item.phase }
}
